module.exports = __webpack_public_path__ + "media/images/logo_pl-cfd383b0f74021d364f0143eeac5b7c9.svg";